import { StockGroupTableHeadersType } from "../tableHeadersType";

export const STOCK_GROUP_MANAGER_HEADERS: StockGroupTableHeadersType[] = [
  {
    "label": "Stock Group",
    "value": "stock_group_id",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Stock Group Name",
    "value": "stock_group_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Parent Account",
    "value": "Parent Account",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Added/Modified By",
    "value": "updated_at",
    "defaultChecked": true,
    "checked": true
    }
]